// 监听短链接和分享码进行微信分享初始化
import { to } from '@tencent/wphk-base-utils';
import { setUpWeixin, setWxShareInfo } from '@tencent/wphk-act-base-framework';
import { WxShareInfo } from '@tencent/wphk-base-wx';
import { CustomException } from '@tencent/ppd-base-libs';

export const useWxShare = async (shareInfo: WxShareInfo) => {
  // 初始化微信
  const [err] = await to(setUpWeixin());
  if (err) {
    new CustomException(err, 'setUpWeixinFail', '初始化微信分享失败');
  }
  // 设置微信分享信息
  handleSetWxShareInfo(shareInfo);
};

/**
 * 设置微信分享内容
 * @param link 原链接 + 分享码 + adtag
 */
function handleSetWxShareInfo(shareInfo: WxShareInfo) {
  // 设置 h5 分享信息
  setWxShareInfo({ wx: shareInfo });
}
